module.exports = __webpack_public_path__ + "img/iam.cfe259f.svg";